// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121736/js/" + chunkId + "." + {"44":"69fc016a","225":"9a4204b5","481":"eb5b894b","486":"77826ca9","770":"a17401f9"}[chunkId] + ".0.05398584827196018.chunk.js";
};